import * as React from "react";
import Archive from "@material-ui/icons/Archive";
import Button from "@material-ui/core/Button";
import PropTypes from "prop-types";

import {
  Info_Tile,
  UpdateInfoTileStatusDocument,
} from "../../../types/generated/gql";
import { client } from "../../../dataProvider";

interface Props {
  record: Info_Tile;
  onArchived: () => unknown;
}

const ArchiveButton = ({ record, onArchived }: Props) => {
  const [loading, setLoading] = React.useState(false);

  return (
    <Button
      variant="outlined"
      color="primary"
      size="small"
      onClick={() => {
        setLoading(true);

        client
          .mutate({
            mutation: UpdateInfoTileStatusDocument,
            variables: {
              id: record.id,
              status: "ARCHIVED",
            },
          })
          .then((result) => {
            setLoading(false);

            onArchived();
          })
          .catch((error) => {
            setLoading(false);
          });
      }}
      disabled={loading}
    >
      <Archive
        color="primary"
        style={{ paddingRight: "0.5em", color: "red" }}
      />
      Archive
    </Button>
  );
};

ArchiveButton.propTypes = {
  record: PropTypes.any,
};

export default ArchiveButton;
